import {
	PublicInstitutesTagIcon,
	CommerceTagIcon,
	OpenFieldTagIcon,
	OfficesTagIcon,
	ResidenceTagIcon,
	TransportationTagIcon,
	LightRailTagIcon,
    PlusTagIcon,
	RiverTagIcon
} from '../../../assets/icons/';

export default {
	PublicInstitutesTagIcon,
	CommerceTagIcon,
	OpenFieldTagIcon,
	OfficesTagIcon,
	ResidenceTagIcon,
	TransportationTagIcon,
    PlusTagIcon,
	LightRailTagIcon,
	RiverTagIcon
};